// extracted by css-extract-rspack-plugin
export default {"Filter_0":"filter-bar-module__Filter_0__PEFr7"};